import { commandKeySymbol, optionsKeySymbol } from 'common/ProseInput/Keymap'
import Styles from './KeyboardShortcutTag.module.scss'
import cx from 'classnames'

type ModifierKey = 'Mod' | 'Shift' | 'Opt'
type ModifierMap = {
  [K in ModifierKey]: string
}

const modifierMap: ModifierMap = {
  Mod: commandKeySymbol(),
  Shift: '⇧',
  Opt: optionsKeySymbol(),
}

export interface KeyboardShortcutTagProps {
  modifiers: ModifierKey[]
  keys: string
  className?: string
  prefix?: string
}

export const KeyboardShortcutTag = ({ modifiers, keys, className, prefix }: KeyboardShortcutTagProps) => {
  const modifierStrings = modifiers.map((modifier) => modifierMap[modifier])
  const allKeys = [prefix, ...modifierStrings, keys.toUpperCase()].filter(Boolean) as string[]

  return (
    <div className={Styles.container}>
      {allKeys.map((key, index) => (
        <kbd key={index} className={cx(Styles.shortcut, className)}>
          {key}
        </kbd>
      ))}
    </div>
  )
}
